import createReducer from '../../lib/createReducer'

import {
  TOPIC_FOLLOW_FAILURE,
  TOPIC_FOLLOW_REQUEST,
  TOPIC_FOLLOW_SUCCESS,
} from '../actions/topicFollowActions'

const applyFollowState = (state, slug, following, count) => ({
  items: following
    ? [...state.items.filter(item => item !== slug), slug]
    : state.items.filter(item => item !== slug),
  counts: {
    ...state.counts,
    [slug]: Math.max(0, count),
  },
})

export default createReducer({
  items: [],
  counts: {},
}, {
  [TOPIC_FOLLOW_REQUEST]: ({ payload, meta }, state) => {
    const { slug, wantFollowing, previousCount } = payload || meta
    const base = Object.prototype.hasOwnProperty.call(state.counts, slug)
      ? state.counts[slug]
      : previousCount
    const count = wantFollowing ? base + 1 : base - 1
    return applyFollowState(state, slug, wantFollowing, count)
  },
  [TOPIC_FOLLOW_SUCCESS]: ({ payload }, state) => applyFollowState(
    state,
    payload.slug,
    payload.following,
    payload.followers_count,
  ),
  [TOPIC_FOLLOW_FAILURE]: ({ meta }, state) => {
    const { slug, wantFollowing, previousCount } = meta
    return applyFollowState(state, slug, !wantFollowing, previousCount)
  },
})
